export default __webpack_public_path__ + "static/media/07.55ad22d5.jpg";